import React from 'react';
import { Link } from 'react-router-dom';
import { stores } from '../data/mockData';
import { ArrowRight, Star } from 'lucide-react';

const StoreLogos = () => {
  // Motorcycle gear store logos with brand colors
  const storeLogos = {
    alpinestars: { text: 'ALPINESTARS', color: '#000000', bg: '#fff', font: 'font-bold text-base md:text-lg tracking-wide' },
    dainese: { text: 'DAINESE', color: '#000000', bg: '#fff', font: 'font-bold text-lg md:text-xl tracking-wider' },
    revit: { text: "REV'IT!", color: '#e31837', bg: '#fff', font: 'font-black text-lg md:text-xl' },
    shoei: { text: 'SHOEI', color: '#c8102e', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-wide' },
    agv: { text: 'AGV', color: '#ff0000', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    arai: { text: 'Arai', color: '#000000', bg: '#fff', font: 'font-bold text-xl md:text-2xl italic' },
    held: { text: 'HELD', color: '#e31837', bg: '#fff', font: 'font-black text-xl md:text-2xl tracking-wider' },
    klim: { text: 'KLIM', color: '#ff6600', bg: '#fff', font: 'font-black text-xl md:text-2xl tracking-widest' },
    'sw-motech': { text: 'SW-MOTECH', color: '#003366', bg: '#fff', font: 'font-bold text-base md:text-lg' },
    givi: { text: 'GIVI', color: '#e31837', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    sena: { text: 'SENA', color: '#0066cc', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-wide' },
    tcx: { text: 'TCX', color: '#000000', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    sidi: { text: 'SIDI', color: '#e31837', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    oxford: { text: 'OXFORD', color: '#000000', bg: '#fff', font: 'font-bold text-lg md:text-xl tracking-wide' },
    rukka: { text: 'RUKKA', color: '#ff6600', bg: '#fff', font: 'font-black text-xl md:text-2xl tracking-wider' },
    icon: { text: 'ICON', color: '#000000', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    'bell-helmets': { text: 'BELL', color: '#e31837', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
    hjc: { text: 'HJC', color: '#003399', bg: '#fff', font: 'font-black text-2xl md:text-3xl' },
  };

  const renderStoreLogo = (store) => {
    const logoInfo = storeLogos[store.slug];
    if (!logoInfo) {
      return <span className="text-lg font-bold text-slate-700">{store.name}</span>;
    }

    return (
      <span
        className={`${logoInfo.font || 'text-xl md:text-2xl font-bold'}`}
        style={{ color: logoInfo.color }}
      >
        {logoInfo.text}
      </span>
    );
  };

  // Display top motorcycle gear stores
  const displayStores = stores.slice(0, 10);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Star className="w-5 h-5 text-[#fed900] fill-[#fed900]" />
              <span className="text-sm font-semibold text-[#1a1a1a] uppercase tracking-wider">Featured</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">Popular Stores</h2>
          </div>
          <Link 
            to="/stores" 
            className="flex items-center gap-2 text-[#1a1a1a] font-semibold hover:text-[#fed900] transition-colors group"
          >
            View all stores
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Store Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {displayStores.map((store, index) => (
            <Link
              key={store.id}
              to={`/store/${store.slug}`}
              className="group bg-white border-2 border-slate-100 rounded-2xl p-6 flex items-center justify-center min-h-[100px] md:min-h-[120px] hover:border-[#fed900] hover:shadow-xl hover:shadow-[#fff9d9]/50 transition-all duration-300 animate-fadeInUp opacity-0"
              style={{ animationDelay: `${index * 0.05}s`, animationFillMode: 'forwards' }}
            >
              <div className="transform group-hover:scale-110 transition-transform duration-300">
                {renderStoreLogo(store)}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoreLogos;
